export default process.env.PUBLIC_URL +
  process.env.REACT_APP_LOCAL_URL +
  "/mercury_logo.svg";
